// extracted by mini-css-extract-plugin
export var barContainer = "_2s-0";
export var extraThin = "_2s-3";
export var fillBar = "_2s-6";
export var fillContainer = "_2s-4";
export var overflow = "_2s-8";
export var overflowContainer = "_2s-5";
export var regular = "_2s-7";
export var thick = "_2s-1";
export var thin = "_2s-2";